import { Stack } from '@mui/material';
import React, { ReactNode } from 'react';

import S3Upload from '../../../../forms/S3Upload';

interface UploadHandlerProps {
  s3InfoUrl: string;
  generateKey: () => string;
  accept?: string;
  onStart?: (files: File[]) => void;
  onSuccess?: (links: string, path: string, files: File[]) => void;
  onFailure?: (error: any) => void;
  label?: ReactNode;
  disabled?: boolean;
  variant?: any;
  sx?: any;
  preserveName?: boolean;
  multiple?: boolean;
  isReplace?: boolean;
  replaceLabel?: ReactNode;
  name: string;
}

function UploadHandler({
  s3InfoUrl,
  generateKey,
  onStart,
  onSuccess,
  onFailure,
  label,
  accept = '.png,.jpg,.jpeg,.gif',
  disabled,
  variant,
  sx,
  preserveName,
  multiple,
  isReplace,
  replaceLabel,
  name,
}: UploadHandlerProps) {
  return (
    <Stack alignItems="flex-start">
      <S3Upload
        s3InfoUrl={s3InfoUrl}
        generateKey={generateKey}
        accept={accept}
        onStart={onStart}
        onSuccess={onSuccess}
        onFailure={onFailure}
        label={label}
        disabled={disabled}
        variant={variant}
        sx={sx}
        preserveName={preserveName}
        multiple={multiple}
        isReplace={isReplace}
        replaceLabel={replaceLabel}
        name={name}
      />
    </Stack>
  );
}

export default UploadHandler;